import type { ReactNode } from 'react';

type DTCellProps = {
  text: string;
  icon?: ReactNode;
  textAlign?: 'text-left' | 'text-center' | 'text-right';
};

export const DTCell = ({ text, icon, textAlign }: DTCellProps) => {
  return (
    <div className={`flex flex-row gap-x-2 items-center ${textAlign}`}>
      {icon}
      <p className="text-white text-sm">{text}</p>
    </div>
  );
};
